<template>
  <div class="vs-container" style="padding-right: 20%">
    <div class="title">个人信息</div>
    <div class="bottom_line">头像信息</div>
    <avat style="margin-left: 20px" />
    <div class="bottom_line">基础信息</div>
    <base-info />
  </div>
</template>
<script>
import Avat from './components/Avat'
import BaseInfo from './components/BaseInfo/index.vue'

export default {
  components: { Avat, BaseInfo },
  created() {
  }
}
</script>
<style scoped>
  .vs-container{
    padding: 30px;
  }
.title{
  color: #3C4353;
  font-size: 20px;
  font-weight: 500;
}
.bottom_line{
  height: 40px;
  line-height: 40px;
  font-size: 12px;
  font-weight: 600;
  color: #3C4353;
  border-bottom: 1px solid #D8D8D8;
  margin: 10px 0;
}
</style>